<!-- eslint-disable vue/no-v-html -->
<template>
  <transition-group name="fade" tag="section" class="gdpr w-100 mb-4">
    <div key="caption" class="caption"><span v-html="formConfig.gdpr_text"></span></div>
    <v-radio-group
      key="email-opt-in"
      v-model="emailOptIn"
      :disabled="!isInteractive"
      :rules="rules.required"
      row
    >
      <v-radio value="YES">
        <template #label>
          <strong>{{ $t('action.optInYesLabel', locale) }}</strong>
        </template>
      </v-radio>
      <v-radio value="NO">
        <template #label>
          <strong>{{ $t('action.optInNoLabel', locale) }}</strong>
        </template>
      </v-radio>
    </v-radio-group>
    <div
      v-show="optOutChosen"
      key="opt-out-challenge"
      class="gdpr-challenge"
      v-html="formConfig.gdpr_opt_out_challenge"
    />
  </transition-group>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'SectionDataConsent',
  data: vm => ({
    emailOptIn: null,
    rules: {
      required: [v => !!v || vm.$t('action.fields.generic.validation.required', vm.locale)]
    }
  }),
  computed: {
    ...mapState('actionForm', ['formConfig', 'locale', 'formData']),
    ...mapGetters('actionForm', ['isInteractive', 'optOutChosen'])
  },
  watch: {
    emailOptIn(value) {
      this.$store.commit('actionForm/UPDATE_FORM_DATA_FIELD_VALUES', {
        fieldConfig: {
          name: 'user_gdpr_opt'
        },
        value
      })
    }
  },
  created() {
    if (this.formData.user_gdpr_opt) {
      this.emailOptIn = this.formData.user_gdpr_opt
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_panels-common.scss';

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

::v-deep {
  .v-input.opt-in {
    .v-input__control {
      .v-input__slot {
        .v-input--radio-group__input {
          display: flex;
        }
      }
    }
  }
  p {
    margin: 0 !important;
  }
}
</style>
